/* eslint-disable no-unused-vars */
export default {
    clearStart: function() {
        window.localStorage.removeItem('subLadeOpMaatCatInfo');
        window.localStorage.removeItem('subLadeOpMaatCat');
        window.localStorage.removeItem('catLadeOpMaatDetail');
        window.localStorage.removeItem('preSteps');
        window.localStorage.removeItem('steps');
        window.localStorage.removeItem('currentStep');
        window.localStorage.removeItem('totalprice');
    },

    runMounted: function (getThis) {
        let me = getThis;
        let localstorageEnabled = false;
        let dochash = '';
        if (document.getElementById('duo-current-hash')) {
            dochash = document.getElementById('duo-current-hash').value;
        }
        const runDocHash = true;
        if (dochash && runDocHash) {
            window.localStorage.removeItem('subLadeOpMaatCatInfo');
            window.localStorage.removeItem('subLadeOpMaatCat');
            window.localStorage.removeItem('catLadeOpMaatDetail');
            window.localStorage.removeItem('preSteps');
            window.localStorage.removeItem('steps');
            window.localStorage.removeItem('currentStep');
            window.localStorage.removeItem('totalprice');

            //set hash, article type (kind) and brand
            me.currentHash = dochash;
            const docbrand = Number(document.getElementById('duo-current-article-brand').value);
            const docType = Number(document.getElementById('duo-current-article-kind').value);
            const docArticle = Number(document.getElementById('duo-current-article').value);


            let array;
            array = JSON.stringify(me.stepperSteps);
            array = JSON.parse(array);
            if (!array) {
                return false;
            }

            let brand = array[0].accordion[0].items[0];
            let brandOptions = brand.options;
            let type = array[0].accordion[1].items[0];
            let typeOptions = type.options;
            let article = array[0].accordion[2].items[0];
            let articleOptions = article.options;

            let getBrand = brandOptions.filter(item => item.catid === docbrand);
            let getType = typeOptions.filter(item => item.catid === docType);
            let getArticle = articleOptions.filter(item => item.productId === docArticle);

            brand.value = getBrand[0]['label'];
            brand.valCode = getBrand[0]['valCode'];
            brand.catid = 'cat' + getBrand[0]['catid'];
            brand.selectedLabel = getBrand[0]['label'];
            me.selectedBrand = docbrand;
            me.step1Brand = getBrand[0]['valCode'];

            type.value = getType[0]['label']+getType[0]['parentId'];
            type.valCode = getType[0]['valCode'];
            type.catid = getType[0]['catid'];
            type.selectedLabel = getType[0]['label'];
            me.selectedType = docType;
            me.step1Type = getType[0]['valCode'];

            article.value = getArticle[0]['productId'];
            article.selectedLabel = getArticle[0]['label']+' mm';
            article.selectedPrice = getArticle[0]['price'];
            me.step1Height = getArticle[0]['valCode'];
            me.stepperSteps = array;
            // localStorage.steps = JSON.stringify(this.stepperSteps);
            let selectedArtId = getArticle[0];

            me.getOptionsCustomProducts(selectedArtId, me.stepperSteps, me.currentHash);

            // Change url of page without reload
            var url = window.location.href;
            var arr = url.split('index/sArticle');
            arr.pop();
            //alert(arr[0]);
            window.history.pushState('page2', 'Title', arr[0]);
        } else {
            // get the Categories for the first step from Shopware API
            if (localStorage.steps) {
                if(localstorageEnabled) {
                    const localsteps = localStorage.steps;
                    var array = JSON.parse(localsteps);

                    var docbrand = array[0].accordion[0].items[0].valCode;
                    var docType = Number(localStorage.step1TypeProductID);
                    var docArticle = Number(localStorage.step1HeightproductID);

                    // window.localStorage.removeItem('subLadeOpMaatCatInfo');
                    // window.localStorage.removeItem('subLadeOpMaatCat');
                    // window.localStorage.removeItem('catLadeOpMaatDetail');
                    // window.localStorage.removeItem('preSteps');
                    // window.localStorage.removeItem('steps');
                    // window.localStorage.removeItem('currentStep');
                    // window.localStorage.removeItem('totalprice');

                    let brand = array[0].accordion[0].items[0];
                    let brandOptions = brand.options;
                    let type = array[0].accordion[1].items[0];
                    let typeOptions = type.options;
                    let article = array[0].accordion[2].items[0];
                    let articleOptions = article.options;

                    let getBrand = brandOptions.filter(item => item.valCode === docbrand);
                    let getType = typeOptions.filter(item => item.catid === docType);
                    let getArticle = articleOptions.filter(item => item.productId === docArticle);

                    // brand.value = getBrand[0]['label'];
                    // brand.valCode = getBrand[0]['valCode'];
                    // brand.catid = 'cat' + getBrand[0]['catid'];
                    // brand.selectedLabel = getBrand[0]['label'];
                    me.selectedBrand = Number(localStorage.selectedBrand);
                    me.step1Brand = getBrand[0]['valCode'];

                    // type.value = getType[0]['label']+getType[0]['parentId'];
                    // type.valCode = getType[0]['valCode'];
                    // type.catid = getType[0]['catid'];
                    // type.selectedLabel = getType[0]['label'];
                    me.selectedType = docType;
                    me.step1Type = getType[0]['valCode'];

                    // article.value = getArticle[0]['productId'];
                    // article.selectedLabel = getArticle[0]['label']+' mm';
                    // article.selectedPrice = getArticle[0]['price'];

                    me.step1Height = getArticle[0]['valCode'];
                    //let selectedArtId = getArticle[0];

                    //me.getOptionsCustomProducts(selectedArtId, me.stepperSteps);
                    //me.stepperSteps = array;

                    me.loadingSubsteps = false;
                    me.LoadingCustomProducts = false;
                    me.nextStep(Number(localStorage.currentStep - 1));
                } else {
                    window.localStorage.removeItem('subLadeOpMaatCatInfo');
                    window.localStorage.removeItem('subLadeOpMaatCat');
                    window.localStorage.removeItem('catLadeOpMaatDetail');
                    window.localStorage.removeItem('preSteps');
                    window.localStorage.removeItem('steps');
                    window.localStorage.removeItem('currentStep');
                    window.localStorage.removeItem('totalprice');

                    window.localStorage.removeItem('selectedBrand');
                    window.localStorage.removeItem('step1HeightproductID');
                    window.localStorage.removeItem('step1Height');
                    window.localStorage.removeItem('step1TypeProductID');
                    window.localStorage.removeItem('step1Type');
                    window.localStorage.removeItem('step1Brand');
                    window.localStorage.removeItem('step1productID');
                }
            }

        }
    }
}
/* eslint-enable no-unused-vars */
